import intl from 'react-intl-universal'
import { LOCALE } from '@foxrenderfarm/internals'
import { ProductDesktopIcon, ProductRenderingIcon } from '../../../svg'
import { MainLink, getLocalAppOrigin, isPathActive } from '../../light-dropdowns/common'

interface ProductsPanelProps {
  currentLocale: LOCALE
  currentPathname: string
  origin: string
}

export const ProductsPanel = ({ currentLocale, currentPathname, origin }: ProductsPanelProps) => {
  const useGatsbyLink = process.env.GATSBY_PACKAGE_NAME === 'main'
  const mainOrigin = getLocalAppOrigin(origin, 8084)
  const items = [
    {
      to: '/cloud-rendering.html',
      label: intl.get('index.header.products.online'),
      Icon: ProductRenderingIcon,
    },
    {
      to: '/download.html',
      label: intl.get('index.header.products.desktop'),
      Icon: ProductDesktopIcon,
    },
  ]

  return (
    <>
      {items.map((item) => {
        const Icon = item.Icon
        return (
          <MainLink
            key={item.to}
            to={item.to}
            href={`${mainOrigin}${item.to}`}
            useGatsbyLink={useGatsbyLink}
            locale={currentLocale}
            $highlight={isPathActive(currentPathname, item.to, currentLocale)}
            className='products-main-link'
          >
            {Icon && <Icon style={{ marginRight: 4 }} />}
            {item.label}
          </MainLink>
        )
      })}
    </>
  )
}
